<template>
  <div class="wrapper flex-col">
    <div class="head flex-row-space-between">
      <div class="flex-center" @click="goBack">
        <img src="../../assets/images/course_2.0/返回.png" alt="" />
      </div>
      <div class="head_l">
        <div class="flex-center">
          <div class="head_l_title">{{ $route.query.homework_title }}</div>
          ({{ this.$route.query.student_name }})
          <div class="score">得分:{{ score }}</div>
        </div>
      </div>
      <div>
        <!-- <el-button type="primary" @click="onSubmit">打分完成</el-button> -->
        <el-button type="primary" @click="onSubmit()">打分完成</el-button>
      </div>
    </div>

    <!-- 作业批改样式修改 -->
    <div class="flex-row content_box">
      <div class="content_left flex-col">
        <div class="student_answerBox flex-col">
          <div class="img_BOX">
            <div class="img_box" ref="rotate">
              <!-- <img :src="fileInfo.url" alt=""> -->
              <!-- <el-image :src="fileInfo.url" alt="" :preview-src-list="[fileInfo.url]"></el-image> -->
              <div class="drawer_correct_canvas" v-show="homework_detail.answer_card_img">
                <div class="correct_screen_list_item_head">
                  <div></div>
                  <div class="correct_screen_list_item_head_opreation">
                    <div @click="last_img()">
                      <span class="iconfont iconxiangzuojiantou"></span>
                    </div>
                    <div @click="next_img()">
                      <span class="iconfont iconxiangyoujiantou"></span>
                    </div>
                    <div @click="blow_up()">
                      <span class="iconfont el-icon-zoom-in"></span>
                    </div>
                    <div @click="blow_down()">
                      <span class="iconfont el-icon-zoom-out"></span>
                    </div>
                    <div @click="canvas_rotate()">
                      <span class="iconfont iconxuanzhuan2"></span>
                    </div>
                    <div
                      :class="
                        show_canvas_operation_type == 'pen'
                          ? 'show_canvas_operation_type_active'
                          : ''
                      "
                      @click="open_close_pen()"
                    >
                      <span class="iconfont iconpigai1"></span>
                    </div>
                    <div
                      :class="
                        show_canvas_operation_type == 'eraser'
                          ? 'show_canvas_operation_type_active'
                          : ''
                      "
                      @click="eraser()"
                    >
                      <span class="iconfont iconxiangpi1"></span>
                    </div>
                    <div @click="canvas_remove()">
                      <span class="iconfont iconshanchu4"></span>
                    </div>
                    <div @click="save_canvas_imglise()"><span>保存</span></div>
                  </div>
                </div>
                <div class="correct_screen_list_item_main_box">
                  <div style="height: 1px"></div>
                  <div class="correct_screen_list_item_canvas">
                    <iframe
                      src="https://www.gaokaowin.com/myCanvas/online/newCanvas.html"
                      width="100%"
                      height="100%"
                      ref="newCanvas"
                      name="newCanvas"
                      id="newCanvas"
                    ></iframe>
                    <!-- <iframe
                      src="http://localhost:8091/newCanvas.html"
                      width="100%"
                      height="100%"
                      ref="newCanvas"
                      name="newCanvas"
                      id="newCanvas"
                    ></iframe> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="flex-1 flex-center" style="cursor: pointer">作业答案</div> -->
      </div>
      <div class="content_right">
        <div class="flex-row-space-between" style="margin-bottom: 20px">
          <div class="title">教师打分</div>
          <div class="numTitle">总得分：{{ score }}</div>
        </div>

        <div>
          <div class="scoreBox" v-for="(item, index) in homeworkList" :key="index">
            <div class="tMItemBox">
              <div class="tMItemTitle flex-row-space-between">
                <span>
                  {{ item.name }}
                </span>
                <span>大题分:{{ item | countScore }}</span>
              </div>
              <div v-for="(data, key) in item.topicList" :key="key">
                <div
                  class="flex-row-v-center"
                  style="margin-bottom: 20px; flex-wrap: wrap"
                  v-if="!Array.isArray(data)"
                >
                  <div>{{ key + 1 }}、</div>
                  <div class="scoreItem">
                    <el-input-number
                      controls-position="right"
                      style="width: 80px"
                      :step="0.5"
                      v-model="data.score"
                      :min="0"
                      :max="data.src_score"
                      :controls="false"
                      @change="changeNum(data)"
                    ></el-input-number>
                  </div>
                  <div class="iconBox">
                    <!-- <img @click="onClick(item, 1)" src="../../assets/images/course_2.0/cuo.png" alt="" /> -->
                    <div class="iconBoxItem flex-center" @click="onClick(data, 1)">
                      错
                    </div>
                  </div>
                  <div class="iconBox">
                    <!-- <img @click="onClick(item, 2)" src="../../assets/images/course_2.0/dui.png" alt="" /> -->
                    <div class="iconBoxItem2 flex-center" @click="onClick(data, 2)">
                      对
                    </div>
                  </div>
                </div>
                <div class="flex-row-v-center scoreBox" style="flex-wrap: wrap" v-else>
                  <div
                    class="flex-row-v-center"
                    style="margin-bottom: 20px; margin-right: 10px"
                    v-for="(listItem, key2) in data"
                    :key="key2"
                  >
                    <div>{{ key + 1 }}-{{ key2 + 1 }}、</div>
                    <div class="scoreItem">
                      <el-input-number
                        controls-position="right"
                        style="width: 80px"
                        :step="0.5"
                        v-model="listItem.score"
                        :min="0"
                        :max="listItem.src_score"
                        :controls="false"
                        @change="changeNum(data)"
                      ></el-input-number>
                    </div>
                    <div class="iconBox">
                      <!-- <img @click="onClick(data, 1)" src="../../assets/images/course_2.0/cuo.png" alt="" /> -->
                      <div class="iconBoxItem flex-center" @click="onClick(listItem, 1)">
                        错
                      </div>
                    </div>
                    <div class="iconBox">
                      <!-- <img @click="onClick(data, 2)" src="../../assets/images/course_2.0/dui.png" alt="" /> -->
                      <div class="iconBoxItem2 flex-center" @click="onClick(listItem, 2)">
                        对
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import bus from "../../plugins/Bus";
export default {
  data() {
    return {
      homework_detail: "",
      isSubmit: false,
      homeworkList: [],
      answer_card_img: [],
      current_drawer_item_index_answer: 0, //学生答案index
      show_canvas_operation_type: "pen",
      score: 0,
      fileInfo: {
        url: "",
        deg: 0,
        multiples: 1,
      },
      currentPage: 0,
      type: "",
    };
  },
  filters:{
    countScore(val){
      let score = 0;
      val.topicList.forEach((data) => {
          if (Array.isArray(data)) {
            for (let num in data) {
              if (data[num].score == -1 || data[num].score == undefined) {
              } else {
                score += Number(data[num].score);
              }
            }
          } else {
            if (data.score == -1 || data.score == undefined) {
            } else {
              score += Number(data.score);
            }
          }
        });
      return score
    }
  },

  mounted() {
    this.getDetail();
    window.save_canvas_imglise_upload_data = this.save_canvas_imglise_upload_data;
  },
  methods: {
    get_iframe() {
      let _this = this;
      const iframe = _this.$refs.newCanvas;
      // 处理兼容行问题
      setTimeout(function () {
        _this.call_iframe(
          JSON.parse(JSON.stringify(_this.homework_detail.cardimg_answer)),
          "setImgList"
        );
        _this.call_iframe("", "touchOpen");
        _this.call_iframe(
          {
            width: document.getElementById("newCanvas").clientWidth,
            height: document.getElementById("newCanvas").clientHeight,
          },
          "canvasChange"
        );
      }, 1000);

      return;
    },
    last_img() {
      // if (this.current_drawer_item_index_answer > 0) {
      //   this.current_drawer_item_index_answer = this.current_drawer_item_index_answer - 1;
      //   this.call_iframe(this.current_drawer_item_index_answer, "setImgIndex");
      // } else {
      //   this.$message({
      //     type: "error",
      //     message: "已经是第一张了！",
      //     durtion: 1500,
      //     showClose: true,
      //   });
      // }
      // this.call_iframe('','canvasChange')
      this.type = "last";
      this.save_canvas_imglise();
    },
    next_img() {
      // if (
      //   this.current_drawer_item_index_answer <
      //   this.homework_detail.cardimg_answer.length - 1
      // ) {
      //   this.current_drawer_item_index_answer = this.current_drawer_item_index_answer + 1;
      //   this.call_iframe(this.current_drawer_item_index_answer, "setImgIndex");
      // } else {
      //   this.$message({
      //     type: "error",
      //     message: "已经是最后张了！",
      //     durtion: 1500,
      //     showClose: true,
      //   });
      // }
      this.type = "next";
      this.save_canvas_imglise();
    },
    // 画笔
    open_close_pen() {
      if (this.show_canvas_operation_type == "pen") {
        this.call_iframe("", "touchClose");
        this.show_canvas_operation_type = "";
      } else {
        this.call_iframe("", "touchOpen");
        this.show_canvas_operation_type = "pen";
      }
      // this.call_iframe('','canvasChange')
    },
    // 放大
    blow_up() {
      // window.frames['newCanvas'].webFunction()
      this.call_iframe("", "ratio1");
      // this.call_iframe('','canvasChange')
    },
    blow_down() {
      this.call_iframe("", "ratio2");
    },
    canvas_rotate() {
      this.call_iframe("", "rotate1");
    },
    eraser() {
      this.call_iframe("", "erase");
      this.call_iframe("", "doeErase");
      this.show_canvas_operation_type = "eraser";
    },
    canvas_remove() {
      this.call_iframe("", "eraseAll");
    },
    save_canvas_imglise() {
      let userinfo = JSON.parse(sessionStorage.userInfo);
      this.call_iframe(
        {
          server_url: userinfo.school.server_url,
          token: sessionStorage.token,
          keyValue: sessionStorage.keyValue,
          school_code: userinfo.school_code,
        },
        "thumbImg"
      );
      // return
    },
    save_canvas_imglise_upload_data() {
      //console.log(window.frames["newCanvas"].imgList,this.current_drawer_item_index_answer);
      if (this.type == "next") {
        if (
          this.current_drawer_item_index_answer <
          this.homework_detail.cardimg_answer.length - 1
        ) {
          let arr = JSON.parse(JSON.stringify(window.frames["newCanvas"].imgList));
          this.homework_detail.cardimg_answer[this.current_drawer_item_index_answer] =
            arr[this.current_drawer_item_index_answer];
          this.current_drawer_item_index_answer =
            this.current_drawer_item_index_answer + 1;
          this.call_iframe(this.current_drawer_item_index_answer, "setImgIndex");
        } else {
          this.$message({
            type: "error",
            message: "已经是最后张了！",
            durtion: 1500,
            showClose: true,
          });
        }
      }
      if (this.type == "last") {
        if (this.current_drawer_item_index_answer > 0) {
          let arr = JSON.parse(JSON.stringify(window.frames["newCanvas"].imgList));
          this.homework_detail.cardimg_answer[this.current_drawer_item_index_answer] =
            arr[this.current_drawer_item_index_answer];
          this.current_drawer_item_index_answer =
            this.current_drawer_item_index_answer - 1;
          this.call_iframe(this.current_drawer_item_index_answer, "setImgIndex");
        } else {
          this.$message({
            type: "error",
            message: "已经是第一张了！",
            durtion: 1500,
            showClose: true,
          });
        }
      }
      if (!this.type) {
        let arr = JSON.parse(JSON.stringify(window.frames["newCanvas"].imgList));
        this.homework_detail.cardimg_answer[this.current_drawer_item_index_answer] =
          arr[this.current_drawer_item_index_answer];
        this.onSubmit();
      }
      console.log(this.homework_detail.cardimg_answer);
    },
    submit() {
      this.type = "";
      this.save_canvas_imglise();
    },
    //退出
    goBack() {
      this.$router.go(-1);
    },
    getDetail() {
      let data = {
        id: this.$route.query.id,
      };
      this.axios.post(`/school/Homework_Usages/detail`, data).then((res) => {
        if (res.data.code == 1) {
          this.homework_detail = res.data.data.data;
          let answer_card_img = this.homework_detail.answer_card_img.split(",");
          let cardimg_answer = [];
          // 设置图片初始旋转角度
          answer_card_img.forEach((item) => {
            let obj = {
              url: item,
              deg: 0,
              multiples: 1,
            };
            let data = {
              canvas_data: "",
              image: item,
              thumbnail: item,
            };
            cardimg_answer.push(data);
            this.answer_card_img.push(obj);
          });
          if (this.homework_detail.cardimg_answer) {
          } else {
            this.homework_detail.cardimg_answer = cardimg_answer;
          }

          this.fileInfo = this.answer_card_img[this.currentPage];
          this.homework_detail.tikus_json = JSON.parse(
            this.homework_detail.student_usages_json
          );
          this.homeworkList = JSON.parse(JSON.stringify(this.homework_detail.tikus_json));
          for (let key in this.homework_detail.tikus_json) {
            for (let index in this.homework_detail.tikus_json[key].topicList) {
              //母子题
              if (
                Array.isArray(this.homework_detail.tikus_json[key].topicList[index].score)
              ) {
                let arr = [];
                for (let i in this.homework_detail.tikus_json[key].topicList[index]
                  .score) {
                  let obj = {
                    path: this.homework_detail.tikus_json[key].topicList[index]
                      .children_path[i],
                    score:
                      this.homework_detail.tikus_json[key].topicList[index].score[i] == -1
                        ? undefined
                        : this.homework_detail.tikus_json[key].topicList[index].score[i],
                    src_score: Number(
                      this.homework_detail.tikus_json[key].topicList[index].childScore[i]
                    ),
                  };
                  arr.push(obj);
                }
                this.homeworkList[key].topicList[index] = arr;
              } else {
                let obj = {
                  path: this.homework_detail.tikus_json[key].topicList[index].path,
                  score:
                    this.homework_detail.tikus_json[key].topicList[index].score == -1
                      ? undefined
                      : this.homework_detail.tikus_json[key].topicList[index].score,
                  src_score: Number(
                    this.homework_detail.tikus_json[key].topicList[index].src_score
                  ),
                };
                //this.homeworkList.push(obj);
                this.homeworkList[key].topicList[index] = obj;
              }
            }
          }
          console.log(this.homeworkList, 1111);
          // for (let key in this.homework_detail.tikus_json) {
          //   if (this.homework_detail.tikus_json.hasOwnProperty(key)) {
          //     let obj = {
          //       path: key,
          //       score: this.homework_detail.tikus_json[key].score,
          //       src_score: this.homework_detail.tikus_json[key].src_score,
          //     };
          //     this.homeworkList.push(obj);
          //   }
          // }
          let score = 0;
          this.homeworkList.forEach((item) => {
            item.topicList.forEach((data) => {
              if (Array.isArray(data)) {
                for (let num in data) {
                  if (data[num].score == -1 || data[num].score == undefined) {
                  } else {
                    score += Number(data[num].score);
                  }
                }
              } else {
                if (data.score == -1 || data.score == undefined) {
                } else {
                  score += Number(data.score);
                }
              }
            });
          });
          this.score = score;
          this.get_iframe();
        }
      });
    },
    // 封装调用iframe方法
    call_iframe(data, event) {
      window.messageObj = {
        data: data,
        event: event,
      };
      window.frames["newCanvas"].webFunction();
    },
    // 放大
    magnify() {
      if (this.fileInfo.multiples >= 3) {
        return;
      }
      console.log(this.fileInfo);
      this.fileInfo.multiples += 0.25;
      this.$refs.rotate.style.transform = `rotate(${this.fileInfo.deg}deg)scale(${this.fileInfo.multiples})`;
    },
    // 缩小
    shrink() {
      if (this.fileInfo.multiples <= 0.5) {
        return;
      }
      this.fileInfo.multiples -= 0.25;
      this.$refs.rotate.style.transform = `rotate(${this.fileInfo.deg}deg)scale(${this.fileInfo.multiples})`;
    },
    handleImg(type) {
      if (type === 1) {
        // 上一张
        this.currentPage++;
        if (this.currentPage >= this.answer_card_img.length) {
          this.currentPage = 0;
        }
      } else {
        // 下一张
        this.currentPage--;
        if (this.currentPage < 0) {
          this.currentPage = this.answer_card_img.length - 1;
        }
      }
      // 获取图片当前信息
      this.fileInfo = this.answer_card_img[this.currentPage];
      this.$refs.rotate.style.transform = `rotate(${this.fileInfo.deg}deg)`;
    },
    // 旋转图片
    rotate() {
      this.fileInfo = this.answer_card_img[this.currentPage];
      this.fileInfo.deg += 90;
      if (this.fileInfo.deg >= 360) {
        this.fileInfo.deg = 0;
      }
      this.$refs.rotate.style.transform = `rotate(${this.fileInfo.deg}deg) scale(${this.fileInfo.multiples})`;
    },
    changeNum(item){
      let score = 0;
      this.homeworkList.forEach((item) => {
        item.topicList.forEach((data) => {
          if (Array.isArray(data)) {
            for (let num in data) {
              if (data[num].score == -1 || data[num].score == undefined) {
              } else {
                score += Number(data[num].score);
              }
            }
          } else {
            if (data.score == -1 || data.score == undefined) {
            } else {
              score += Number(data.score);
            }
          }
        });
      });
      this.score = score;
    },
    onClick(item, type) {
      if (type == 1) {
        item.score = 0;
      } else {
        item.score = item.src_score;
      }
      let score = 0;
      this.homeworkList.forEach((item) => {
        item.topicList.forEach((data) => {
          if (Array.isArray(data)) {
            for (let num in data) {
              if (data[num].score == -1 || data[num].score == undefined) {
              } else {
                score += Number(data[num].score);
              }
            }
          } else {
            if (data.score == -1 || data.score == undefined) {
            } else {
              score += Number(data.score);
            }
          }
        });
      });
      this.score = score;
    },
    onSubmit() {
      let data = {
        usages_id: this.$route.query.id,
        batch_score: [],
        cardimg_answer: this.homework_detail.cardimg_answer,
      };
      for (let i in this.homeworkList) {
        for (let a in this.homeworkList[i].topicList) {
          if (Array.isArray(this.homeworkList[i].topicList[a])) {
            for (let num in this.homeworkList[i].topicList[a]) {
              if (
                this.homeworkList[i].topicList[a][num].score == -1 ||
                this.homeworkList[i].topicList[a][num].score == undefined
              ) {
                this.$message({
                  message: `有题目还未打分，请打分`,
                  type: "warning",
                });
                return;
              }
            }
          } else {
            if (
              this.homeworkList[i].topicList[a].score == -1 ||
              this.homeworkList[i].topicList[a].score == undefined
            ) {
              this.$message({
                message: `有题目还未打分，请打分`,
                type: "warning",
              });
              return;
            }
          }
        }
      }
      this.homeworkList.forEach((item) => {
        item.topicList.forEach((itemData) => {
          if (Array.isArray(itemData)) {
            itemData.forEach((item2) => {
              let obj = {
                path: item2.path,
                score: item2.score,
              };
              data.batch_score.push(obj);
            });
          } else {
            let obj = {
              path: itemData.path,
              score: itemData.score,
            };
            data.batch_score.push(obj);
          }
        });
      });
      this.axios.post(`/school/Homework_Usages/submitAnswerCardImg`, data).then((res) => {
        if (res.data.code == 1) {
          this.$message({
            message: "提交成功",
            type: "success",
          });
          this.homeworkList = [];
          this.getDetail();
          this.$router.go(-1);
        }
      });
    },
  },

  beforeDestroy() {},
};
</script>

<style>
.area_popper_batch_set_score {
  border-color: #ff9b36;
  padding: 20px 10px;
}

.area_popper_batch_set_score .popper__arrow::after {
  border-left-color: #ff9b36 !important;
}

.area_popper_course .popper__arrow::after {
  border-bottom-color: #ff9b36 !important;
}

.area_popper_course_show_student_list .popper__arrow::after {
  border-right-color: #ff9b36 !important;
}

.area_popper_course_show_student_list {
  border-color: #ff9b36;
  width: 650px;
  height: 700px;
  /* height: 400px; */
  /* padding-right: 0; */
  padding: 20px 10px;
}

.area_popper_course {
  border-color: #ff9b36;
  max-width: 50px;
  /* height: 400px; */
  padding-right: 0;
}

.color_active {
  color: #ff9b36 !important;
}

.head_l_percentage_bar .el-progress-bar {
  width: 200px;
}

.student_list_box_head .el-switch__core {
  width: 40px !important;
  height: 22px !important;
}
.correct_screen_list_item_head {
  display: flex;
  justify-content: space-between;
  height: 60px;
  line-height: 60px;
  align-items: center;
  color: #ff9b36;
  /* background: red; */
  margin: 0 0 10px 0;
}
.correct_screen_list_item_head_opreation {
  display: flex;
}
.correct_screen_list_item_head_opreation > div {
  margin: 0 10px;
  cursor: pointer;
  color: #999999;
  background: transparent;
  min-width: 30px;
  height: 60px;
  text-align: center;
}
.correct_screen_list_item_head_opreation > div:hover {
  background: #ff9b36;
  color: white;
}
.correct_screen_list_item_canvas {
  flex: 1;
  /* background: green; */
  margin: 10px;
  border: 1px solid #69b4ff;
  border-radius: 6px 20px 20px 6px;
  box-shadow: 0px 4px 4px 0px rgba(3, 50, 92, 0.35);
  overflow: auto;
}
.correct_screen_list_item_main_box {
  border: 4px solid #69b4ff;
  border-radius: 6px 20px 20px 6px;
  box-shadow: 0px 4px 4px 0px rgba(3, 50, 92, 0.35);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: calc(100% - 60px);
  box-sizing: border-box;
}
.correct_screen_list_item_foot_opreation {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #69b4ff;
  padding: 0 10px;
}
.correct_screen_list_item_foot_opreation_save {
  cursor: pointer;
}
.correct_screen_list_item_foot_opreation_mark {
  display: flex;
}
.show_canvas_operation_type_active {
  background: #ff9b36 !important;
  color: #ffffff !important;
}
</style>
<style scoped>
.wrapper {
  background: #f6f6f6;
  height: calc(100vh - 122px);
  padding: 16px 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  position: relative;
}

.head {
  display: flex;
  justify-content: space-between;
  height: 60px;
  line-height: 60px;
  background: #ffffff;
  border-radius: 12px;
  padding: 0 20px;
  position: relative;
}

.head_l {
  display: flex;
  align-items: center;
}

.head_l > div {
  margin-right: 20px;
}

.head_l_topic_index {
  display: flex;
  flex-wrap: wrap;
}

.head_l_topic_index > li {
  width: 30px;
  height: 30px;
  background: #f3f3f3;
  border-radius: 6px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 30px;
  text-align: center;
  margin-right: 17px;
  cursor: pointer;
}

.box_head_l_topic_index {
  margin-bottom: 17px;
}

.head_l_topic_index_list_show_icon {
  width: 16px;
  height: 16px;
  font-size: 16px;
  cursor: pointer;
}

.head_l_percentage_title {
  margin: 0 40px;
}

.head_l_percentage_bar {
  width: 300px;
}

.course_creat_sort_btn {
  height: 36px;
  background: #f8f8f8;
  border-radius: 10px;
  padding: 0 15px;
  line-height: 36px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  margin: 2px 0;
}

.course_creat_sort_options > div {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  height: 35px;
  line-height: 35px;
  width: 138px;
  cursor: pointer;
}

.head_r {
  display: flex;
  align-items: center;
  margin-left: auto;
}

.head_r > div {
  margin-left: 20px;
}

.head_r_topic_detail {
  height: 30px;
  background: #ff9b36;
  border-radius: 6px;
  line-height: 30px;
  padding: 0 20px;
  cursor: pointer;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  margin: 0 20px;
}

.correct_screen_list {
  background: #ffffff;
  /* margin-top: 20px; */
  overflow: hidden;
  padding: 10px 16px;
  display: flex;
  /* justify-content: space-between; */
  flex-wrap: wrap;
  flex: 1;
  box-sizing: border-box;
}

.screen_split_item {
  box-sizing: border-box;
  margin: 10px 0;
  overflow: hidden;
  /* display: flex;
        flex-direction: column; */
}

/* 分屏 */
.creen_split_1 {
  width: 100%;
  height: calc(100% - 20px);
}

.creen_split_2 {
  width: calc((100% - 20px) / 2);
  height: calc(100% - 20px);
}

.creen_split_2:nth-of-type(2n) {
  margin-left: 20px;
}

.creen_split_4 {
  width: calc((100% - 20px) / 2);
  height: calc(50% - 20px);
}

.creen_split_4:nth-of-type(2n) {
  margin-left: 20px;
}

.creen_split_6 {
  width: calc((100% - 40px) / 3);
  height: calc(50% - 20px);
}

.creen_split_6:nth-of-type(3n - 1) {
  margin-left: 20px;
  margin-right: 20px;
}

.creen_split_8 {
  width: calc((100% - 60px) / 4);
  height: calc(50% - 20px);
}

.creen_split_8:nth-of-type(4n) {
  margin-left: 20px;
}

.creen_split_8:nth-of-type(4n -1) {
  margin-left: 20px;
}

.creen_split_8:nth-of-type(4n -2) {
  margin-left: 20px;
}

/*  */
.correct_screen_list_item_head {
  display: flex;
  justify-content: space-between;
  height: 30px;
  line-height: 30px;
  align-items: center;
  color: #ff9b36;
  /* background: red; */
  margin: 0 0 10px 0;
}

.correct_screen_list_item_head_opreation {
  display: flex;
}

.correct_screen_list_item_head_opreation > div {
  margin: 0 10px;
  cursor: pointer;
  color: #999999;
  background: transparent;
  min-width: 30px;
  height: 30px;
  text-align: center;
}

.correct_screen_list_item_head_opreation > div:hover {
  background: #ff9b36;
  color: white;
}

.correct_screen_list_item_canvas {
  flex: 1;
  /* background: green; */
  margin: 10px;
  border: 1px solid #69b4ff;
  border-radius: 6px 20px 20px 6px;
  box-shadow: 0px 4px 4px 0px rgba(3, 50, 92, 0.35);
  overflow: auto;
}

.correct_screen_list_item_main_box {
  border: 4px solid #69b4ff;
  border-radius: 6px 20px 20px 6px;
  box-shadow: 0px 4px 4px 0px rgba(3, 50, 92, 0.35);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: calc(100% - 60px);
  box-sizing: border-box;
}

.correct_screen_list_item_foot_opreation {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #69b4ff;
  padding: 0 10px;
}

.correct_screen_list_item_foot_opreation_save {
  cursor: pointer;
}

.correct_screen_list_item_foot_opreation_mark {
  display: flex;
}

.show_student_list {
  width: 20px;
  height: 20px;
  position: absolute;
  left: 0;
  bottom: 0px;
}

.student_list_box_head {
  display: flex;
  justify-content: space-between;
  padding: 0 10px;
  /* width: 650px; */
  height: 30px;
  line-height: 30px;
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  align-items: center;
}

.student_list_box_head_show_list {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
}

.student_list_box_head_content {
  max-height: 650px;
  margin: 20px;
  box-sizing: border-box;
  overflow: auto;
  display: flex;
  flex-wrap: wrap;
}

.student_list_box_head_content > div {
  width: 144px;
  height: 54px;
  background: #ff9b36;
  border-radius: 12px;
  /* padding: 0 20px; */
  text-align: center;
  line-height: 54px;
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  background: #f3f3f3;
  border-radius: 12px;
  cursor: pointer;
  margin-bottom: 20px;
}

.student_list_box_head_content > div:nth-of-type(3n - 1) {
  margin: 0 81px;
}

.drawer_correct_canvas {
  height: calc(100% - 30px);
  width: calc(100% - 60px);
  margin: 0 30px 30px 30px;
  /* border: 4px solid #69B4FF; */
}

.is_correct_active {
  background: #69b4ff !important;
  color: #ffffff !important;
}

.set_score_all:hover {
  background: #69b4ff !important;
  color: #ffffff !important;
}

.content_box {
  height: calc(100vh - 240px);
  padding-top: 20px;
}

.content_right {
  flex: 1;
  height: 100%;
  background: #fff;
  overflow-y: auto;
  box-sizing: border-box;
  padding: 15px;
  border-radius: 12px;
}

.content_left {
  width: 60vw;
  background: #fff;
  margin-left: 16px;
  margin-right: 16px;
  border-radius: 12px;
  overflow-y: auto;
  padding: 10px;
  /* padding: 10px 16px; */
}

.listItemBox {
  border: 4px solid #69b4ff;
  border-radius: 12px 12px 12px 12px;
  box-shadow: 0px 4px 4px 0px rgba(3, 50, 92, 0.35);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 250px;
  box-sizing: border-box;
  width: 100%;
  cursor: pointer;
}

.listItemBox img {
  width: 100%;
  height: 100%;
}

.studentName {
  margin-top: 5px;
}

.studentNameItem {
  border: 1px solid #69b4ff;
  height: 40px;
  margin-bottom: 10px;
  cursor: pointer;
}

.student_answerBox {
  height: 100%;
}

.title {
  color: #69b4ff;
  font-size: 22px;
  margin-bottom: 15px;
}

.scoreItem {
  display: inline-block;
}

.iconBox {
  width: 35px;
  height: 35px;
  margin: 0px 5px;
  cursor: pointer;
}

.iconBoxItem {
  width: 100%;
  height: 100%;
  background-color: #ff3945;
  border-radius: 8px;
  font-size: 20px;
  color: #ffffff;
}
.iconBoxItem2 {
  width: 100%;
  height: 100%;
  background-color: #409eff;
  border-radius: 8px;
  font-size: 20px;
  color: #ffffff;
}

.score {
  margin-left: 15px;
  color: #69b4ff;
}

.box {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.scoreBox {
  margin-right: 5px;
}

.img_box {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
}

.header {
  height: 60px;
  z-index: 2;
}

.img_BOX {
  height: calc(100% - 60px);
  width: 100%;
  overflow-y: auto;
}

.img_box img {
  max-width: 100%;
  max-height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}
.tMItemTitle {
  font-size: 20px;
  margin-bottom: 15px;
}
.numTitle {
  color: #69b4ff;
  font-size: 20px;
}
</style>
